let client: any | null = null

const supabase = async () => {
  // If the client is already initialized, return it immediately
  if (client) return client

  // Otherwise, dynamically import the library
  const { createClient } = await import("@supabase/supabase-js")

  client = createClient(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
  )

  return client
}

export { supabase }
